import { render, staticRenderFns } from "./VMallCrumbs.vue?vue&type=template&id=45231e1b&scoped=true&"
import script from "./VMallCrumbs.vue?vue&type=script&lang=js&"
export * from "./VMallCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./VMallCrumbs.vue?vue&type=style&index=0&id=45231e1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45231e1b",
  null
  
)

export default component.exports